/* eslint-disable */
'use strict';
exports.__esModule = true;
exports.default = {
    "account": "Akaun",
    "active_date": "Tarikh aktif",
    "address": "Alamat",
    "address2": "Alamat 2 (Pilihan)",
    "amount": "Jumlah",
    "and": "dan",
    "article": "Artikel",
    "buy": "Pembelian",
    "buyer": "Pembeli",
    "buyer_info": "Maklumat pembeli",
    "cancel": "Batal",
    "canceled": "Dibatalkan",
    "cellphone": "Telefon bimbit",
    "certification_expires": "Tidak sah atau tamat tempoh, sila log masuk semula",
    "change_password": "Tukar kata laluan",
    "city": "Bandar",
    "clear": "Kosongkan",
    "commercial": "Komersial",
    "company": "Syarikat",
    "completed": "Selesai",
    "confirm_password": "Sahkan Kata Laluan",
    "contact": "Hubungan",
    "country": "Negara",
    "create": "Cipta",
    "create_account": "Cipta akaun",
    "create_date": "Tarikh Cipta",
    "creationdate": "Tarikh Cipta",
    "currency": "Mata Wang",
    "customer_success": "Pendaftaran berjaya, sila semak e-mel untuk pengaktifan",
    "dead_line": "Tarikh akhir",
    "dealer": "Pengedar",
    "dealer_success": "Menunggu kelulusan",
    "description": "Huraian",
    "domain": "Domain",
    "domain_in_use": "Domain telah digunakan",
    "email": "Emel",
    "email_format_error": "Format e-mel salah",
    "email_used": "E-mel telah digunakan",
    "enter_character": "Sila masukkan aksara dalam gambar",
    "enter_confirm_password": "Masukkan kata laluan baru sekali lagi",
    "enter_new_password": "Masukkan kata laluan baru",
    "enter_old_password": "Masukkan kata laluan lama",
    "erp_list": "Langganan",
    "erp_status": "Status",
    "expire_date": "Tarikh tamat tempoh",
    "female": "Perempuan",
    "first_name": "Nama Pertama",
    "forget_password": "Lupa kata laluan?",
    "forgot_password": "Lupa kata laluan?",
    "form_not_exist": "Borang tidak wujud",
    "format_error": "Ralat Format",
    "group_code": "Kod kumpulan",
    "group_name": "Nama Kumpulan",
    "home_company_address": "Alamat rumah/syarikat",
    "image": "Imej",
    "information_success": "Perubahan maklumat akaun berjaya",
    "initial_info": "Maklumat awal",
    "input_password": "Sila masukkan kata laluan",
    "input_password_again": "Sila masukkan kata laluan sekali lagi",
    "last_name": "Nama keluarga",
    "legal_person": "Entiti sah",
    "male": "Lelaki",
    "modify": "Ubah",
    "modify_erp_information": "Ubah maklumat ERP",
    "modules": "Modul",
    "month": "Pengguna/bulan",
    "name": "Nama",
    "new_password": "Kata Laluan Baharu",
    "new_password_toEmail": "Kata laluan baru telah dihantar ke e-mel anda",
    "next": "Seterusnya",
    "noFoundurl": "Instance tidak wujud",
    "not_null": "Terdapat medan wajib belum diisi",
    "official_website": "Laman rasmi:",
    "ok": "OK",
    "old_password": "Kata Laluan Lama",
    "old_password_error": "Kata laluan lama tidak sepadan",
    "one_time_payment": "Bayaran sekali",
    "operation": "Operasi",
    "or": "ATAU",
    "order": "Pesanan",
    "order-no": "No pesanan",
    "order_close": "Pesanan telah ditutup",
    "order_list": "Senarai pesanan",
    "order_no": "No. Pesanan",
    "order_status": "Status pesanan",
    "other": "Lain-lain",
    "paid": "Dibayar",
    "password": "Kata Laluan",
    "password_error": "Kata laluan mesti 6-20 aksara gabungan huruf dan nombor",
    "password_error_two": "Kata laluan tidak sepadan",
    "password_least": "Kata laluan sekurang-kurangnya 6 aksara dengan nombor dan huruf/aksara khas",
    "password_strength": "Kekuatan Kata Laluan",
    "pay": "Pembelian",
    "pay_error": "Gagal mendapatkan maklumat pembayaran",
    "payment": "Kaedah pembayaran",
    "payment_date": "Tarikh Bayaran",
    "personal": "Peribadi",
    "please_email": "Sila semak e-mel anda",
    "pos": "Posisi",
    "previous": "Sebelumnya",
    "price": "Harga",
    "privacy": "Dengan mencipta akaun SOMATIME, anda bersetuju",
    "privacy_notice": "Polisi privasi",
    "product": "Produk",
    "product_list": "Senarai produk",
    "product_name": "Nama Produk",
    "purchase": "Pembelian",
    "purchase_success": "Pembelian berjaya",
    "refunded": "Dipulangkan",
    "registered": "E-mel telah didaftarkan",
    "registered_email_address": "Kami telah mendaftar dengan e-mel anda",
    "renewal": "Pembaharuan",
    "repeat_password": "Ulang kata laluan",
    "requied": "Wajib",
    "requied_num": "Nombor sahaja",
    "require_tips": "Maklumat pembeli tidak lengkap",
    "required": "Wajib",
    "reseller": "Penjual semula",
    "resend": "Hantar semula",
    "reset_password": "E-mel pautan pengesahan kata laluan telah dihantar ke",
    "revoke": "Batal pesanan",
    "revoke_tip1": "Tutup pesanan semasa?",
    "role": "Peranan",
    "search": "search",
    "send_update": "Hantar kemas kini dari SOMATIME",
    "sex": "Jantina",
    "signIn": "Log Masuk",
    "sign_out": "Log keluar",
    "state": "Negeri/Daerah",
    "status": "Status pembayaran",
    "status_not_match": "Status tidak sepadan",
    "strength_high": "Tinggi",
    "strength_low": "Rendah",
    "strength_mid": "Tengah",
    "submit": "Hantar",
    "submitted": "Dihantar",
    "subscribe": "Langgan",
    "subscribe-mon": "Langgan-bulanan",
    "subscript_success": "Langgan berjaya",
    "telephone": "Telefon",
    "tenant_list": "Senarai tenant",
    "tenant_management_system": "Sistem pengurusan tenant",
    "tenant_system": "Sistem tenant",
    "terms_of_use": "Terma penggunaan",
    "time_info": "Maklumat masa",
    "title": "Tajuk",
    "unpaid": "Belum Dibayar",
    "update_password_success": "Kata laluan berjaya ditukar",
    "user": "Pengguna",
    "user_check": "Sila baca dan setujui polisi privasi dan terma penggunaan",
    "user_id": "ID pengguna",
    "user_month": "Bulan",
    "user_not_active": "Pengguna belum diaktifkan",
    "user_not_exist": "Pengguna tidak wujud",
    "user_password_error": "Kata laluan salah",
    "user_qty": "Bilangan pengguna",
    "username": "Nama pengguna",
    "ver_code_error": "Kod pengesahan salah",
    "ver_code_exd": "Kod pengesahan tamat tempoh",
    "visit": "Lawati",
    "welcome_to_iceq": "SELAMAT DATANG KE SOMATIME",
    "zip": "Poskod",
    "trial": "Percubaan",
    "requesting_a_trial": "Permohonan berjaya! Maklumat demo akan dihantar dalam 24 jam",
    "trial_orders_have_been_requested": "Permintaan percubaan telah dibuat",
    "apply_trial": "Minta demo",
    "request_": "Permintaan",
    "trial_": "Percubaan",
    "on_trial": "Dalam percubaan",
    "order_not_exist": "Pesanan tidak wujud",
    "wait_for_payment": "Menunggu pembayaran",
    "trial_reject": "Demo ditolak",
    "tips": "Petua",
    "confirm": "Sahkan",
    "cancel": "Batal",
    "trial_only_allow_one_time_payment_method": "Trial hanya bayar sekali",
    "domain_info": "Maklumat domain",
    "please_fill_in_domain_info": "Sila isi maklumat domain",
    "user_quantity_and_month_required": "Bil pengguna & bulan diperlukan",
    "password_must_be_the_same": "Sahkan mesti sama",
    "enter_the_password_and_new_password": "Masukkan kata laluan & baru",
    "wrong_user_name_and_password": "Nama pengguna/kata laluan salah",
    "close_the_page_without_saving": "Tutup tanpa simpan?",
    "cancel_input": "Batal input",
    "user_does_not_exist": "Pengguna tidak wujud",
    "modify_success": "Berjaya diubah",
    "email_has_been_used": "E-mel telah digunakan",
    "created_successfully": "Berjaya dibuat",
    "error_tip_10098": "E-mel gagal, hubungi admin",
};